export const handleErrorCode = (error: any) => {
  if (error.code === "card_declined") {
    return "Deine Zahlung wurde abgelehnt. Bitte füge eine neue Zahlungsmethode hinzu und versuche es erneut.";
  } else if (error.code === "payment_intent_authentication_failure") {
    return "Wir konnten deine Zahlungsmethode nicht authentifizieren. Wähle eine andere Zahlungsmethode und versuche es erneut.";
  } else if (error.code === "payment_intent_payment_attempt_failed") {
    return "Deine Zahlung wurde abgelehnt. Bitte füge eine neue Zahlungsmethode hinzu und versuche es erneut.";
  } else {
    return "Es gab einen Fehler bei deiner Zahlung";
  }
};
